import LocalizedStrings from 'react-localization'

export const strings = new LocalizedStrings({
    nb: {
        header: 'Velkommen til Mattilsynets skjematjenester',
        infotext: `<p>Mattilsynet bruker Altinn sin løsning for tilgangsstyring. Informasjon om den løsningen: <a href="https://info.altinn.no/hjelp/ny-tilgangsstyring/">Ny tilgangsstyring</a>.</p>
        </br>`,
        first: {
            header: 'Første gang?',
            info: `<p>Reglene for å logge seg på Mattilsynets skjematjenester:</p>
    </br>
    <ul>
      <li>Ny tilgangspakke: Vi tar i bruk tilgangspakken "Varehandel" fra mars 2026. Vi anbefaler at du legger til denne i Altinn allerede nå.</li>
      <li>Tilgang til enkelttjenester: Hvis du ikke ønsker å gi en fullmakt som dekker hele tilgangspakken, kan du i stedet gi tilgang til enkelttjenester.</li>
      <li>Gamle roller fases ut: Altinn-rollene "Primærnæring" og "Næringsmidler" kan brukes ut 2026, men vil slutte å fungere fra 1. januar 2027.</li>
    </ul>

    <p>Les mer: <a href="https://www.mattilsynet.no/skjema/">www.mattilsynet.no/skjema</a></p>
    </br>
    <p>Mattilsynet har vedlikehold av systemet hver ukedag fra kl. 07.00 til kl. 08.00. Skjematjenestene kan være ustabile eller utilgjengelige i denne perioden.</p>`
        }
    }
})
